import React from 'react';
import PropTypes from 'prop-types';

const Tab = ({
  navigateTo, onClick, name, currentTab
}) => (
  <li>
    <div
      onClick={() => onClick(name, navigateTo)}
      className={`div-ul ${currentTab === name ? 'active active-tab' : ''}`}
      onKeyDown={() => {}}
      role="button"
      tabIndex={0}
    >
      {name}
    </div>

  </li>
);

Tab.propTypes = {
  navigateTo: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  currentTab: PropTypes.string,
};

Tab.defaultProps = {
  currentTab: '',
};
export default Tab;
